const translations = {
  en: {
    SeeButtonSimple: "See in your space",
    whatIncludes : "What includes?",
    prefeerCall : "I prefer to schedule a call",
    ecommerceTittle: "3D Catalog",
    ecommerceText: "Fewer doubts, more sales: showcase your catalog in 3D and turn browsers into buyers.",
    hideBed: "Hide Bed",
    showBed: "Show Bed",
    open: "Open",
    close: "Close",
    services: "Services",
    servicesSub: "We can help you with whatever you need.",
    caseStudies: "Case Studies",
    packs: "Packs",
    packsSub: "Choose the one that best suits your needs.",
    ourServices: "Our Services",
    getStarted: "Get Started",
    bannerMain: "Revolutionize online shopping",
    bannerSecond: "Enhance your buyer's journey\nwith 3D & AR.",
    popUpTittle: "We give you:",
    popUpText: "Our product configurator, Our augmented reality and the 3D model of YOUR product, FREE",
    secondaryBanner: "Benefit Statistics of working with us with striking numbers",
    workTogether: "Why work together with us?",
    reason1: "Reduction in returns",
    reason2: "Lower customer service costs",
    reason3: "Boost your sales",
    reason4: "Increase average ticket size with 3D configurators",
    faq1: "What solutions does Opptix 3D offer to improve product sales and marketing?",
    answer1: "At Opptix 3D, we create innovative visual content such as interactive product configurators, augmented reality (AR), and product animations. These tools transform the customer experience, increasing conversion rates and enhancing engagement on digital platforms.",
    faq2: "How does augmented reality (AR) work in my e-commerce?",
    answer2: "Our AR technology allows customers to visualize products in their real spaces using their mobile device cameras. This not only builds purchase confidence but also reduces returns by aligning expectations with reality.",
    faq3: "What types of products can benefit from 3D configurators?",
    answer3: "3D configurators are ideal for customizable products such as furniture, bicycles, jewelry, watches, appliances, and more. If your product has color, size, material, or accessory variations, a 3D configurator can enhance the customer experience and increase SALES.",
    faq4: "What is the process for creating a 3D model of my product?",
    answer4: "Our process includes: Gathering information (images, technical drawings, or physical samples). 3D modeling with attention to detail and precision. Reviewing and adjusting together with you. Optimization for different uses, such as e-commerce, social media, and marketing campaigns.",
    faq5: "Why choose 3D models over traditional photography?",
    answer5: "3D models allow you to: Show products from all angles. Make quick changes without repeating photo sessions. Create interactive and engaging content. Reduce photography and production costs in the long run.",
    faq6: "Can I use 3D models and animations on social media and advertising campaigns?",
    answer6: "Of course! All our content is optimized for multiple platforms, including social media, websites, e-commerce, and advertising campaigns. We design versatile content to maximize impact in your digital marketing strategy.",
    faq7: "How long does it take to develop 3D configurators, models, or animations?",
    answer7: "The time depends on the project's complexity. For example: 3D configurators: 2-4 weeks. 3D animations: 1-2 weeks. High-quality renders: 3-5 days. We always strive to offer fast solutions without compromising quality.",
    faq8: "How can I implement 3D models on my website?",
    answer8: "We use iframes to embed 3D models and configurators directly into any web platform, without slowing down the site or requiring costly developments. Additionally, our technical team ensures smooth and efficient integration.",
    faq9: "What sets Opptix 3D apart from other visual content agencies?",
    answer9: "We don’t just create content; we design experiences. Our focus is on highlighting the most important features of your products using advanced technology to maximize perceived quality and boost sales. We work closely with you to ensure personalized and effective results.",
    faq10: "How can 3D solutions reduce return rates in e-commerce?",
    answer10: "By offering detailed visualizations, interactive configurators, and AR, your customers gain a clear understanding of the products before purchasing. This reduces misunderstandings and aligns expectations, lowering returns by up to 40%.",
    faq11: "What do the product launch packs include?",
    answer11: "Our launch packs are designed to maximize impact. They include: High-quality 3D renders. 3D explanatory and commercial videos. Animations for social media. Interactive configurators for personalization. Everything is created in collaboration with you to ensure your goals are met.",
    faq12: "How do you measure the impact of 3D models and configurators on my business performance?",
    answer12: "We analyze metrics such as: Increase in conversion rates. Longer time spent on the site. Reduction in return rates. Higher average sales due to customized configurations. We share this data with you so you can see the added value of our solutions.",
    faq13: "How accessible are Opptix 3D services for small and medium-sized businesses?",
    answer13: "We design solutions tailored to different budgets and needs. Whether you're starting out or a large enterprise, our services offer a significant return on investment at competitive prices.",
    faq14: "What if I don’t have an initial 3D model of my product?",
    answer14: "No worries! Our team can create the 3D model from scratch using images, technical drawings, or even detailed descriptions. We take care of everything to ensure optimal results.",
    faq15: "How can I start working with Opptix 3D?",
    answer15: "Simply contact us for an initial call or send us details about your project. We’ll design a personalized plan and guide you step by step to implement solutions that transform your business.",
    faqTitle: "Frequently Asked Questions",
    seeMore : "See More",
    caseStudies: "Case Studies",
    caseStudiesSubt: "The best quality for your brand.",
    showMore: "Show More",
    showLess: "Show Less",

    configText: "Increase your average ticket by 25% and reduce operating costs by 70% with interactive 3D configurators that automate your sales.",
    arText: "Reduce returns by 50%: let your customers try the product before buying.",
    viewerText: "Fewer doubts, more sales: showcase your catalog in 3D and turn browsers into buyers.",
    marketingText: "Double engagement and bring your brand to life with high-impact 3D animations.",
    staticRenderText: "Perfect photos without a photoshoot: 3D renders that showcase your product at its best.",
    interactivAnimText: "Attract, retain, and sell: interactive animations that double retention and engagement.",

    configTittle: "3D Configurators",
    marketingTittle: "3D Animations",
    arTittle: "Augmented Reality",
    staticRenderTittle: "Static Renders",
    viewerTittle: "3D Product Viewer",
    interactivAnimTittle: "Interactive Animations",

    pack1Title: "More confidence, more conversion",  
    pack1Description: "Your customers will be able to view your product from all angles and visualize it in their real space before purchasing. This builds more trust, reduces indecision, and increases the conversion rate in your e-commerce.",  
    pack1MiniDescription: "Your customers will be able to view your product from all angles and visualize it in their real space before purchasing.",
    pack1Price: "From $XXX",  
    pack1SubPrice: "+ Low monthly fee",  
    pack1ResultsTittles: [  
      "40% reduction",  
      "20-30% increase",  
      "Shopping experience"  
    ],  
    pack1Results: [  
      " in returns thanks to a better product perception.",  
      " in conversion rate by eliminating customer doubts.",  
      " that is more immersive and professional, setting you apart from the competition."  
    ],  
    pack1Includes: [  
      "Interactive 3D catalog (iFrame)",  
      "Augmented Reality (AR)",  
      "Web performance optimization"  
    ],  
    
    pack2Title: "More sales, lower costs"  ,
    pack2Description: "Turn your store into a digital showroom where customers can customize products in real time. This not only increases conversion but also boosts the average ticket thanks to customization options and cross-selling",  
    pack2MiniDescription: "Turn your store into a digital showroom where customers can customize products in real time.",
    pack2Price: "From $XXX"  ,
    pack2SubPrice: "+ Intermediate monthly fee"  ,
    pack2ResultsTittles: [  
      "Up to 40% more sales",  
      "Increase in average ticket",  
      "Lower customer service costs"  
    ],  
    pack2Results: [  
      " thanks to interactive customization.",  
      " by offering accessories and additional upgrades.",  
      " as customers design their products without requiring assistance."  
    ],  
    pack2Includes: [  
      "EVERYTHING from Pack 1",  
      "Interactive 3D configurator",  
      "Cross-selling",  
      "UX/UI consulting",  
      "Data analysis",  
      "Render pack"  
    ],  
    
    pack3Title: "Premium Experience"  ,
    pack3Description: "Transform your website into an unforgettable brand experience with interactive animations and 3D models that customers can engage with. This not only enhances brand perception but also positions you as an innovative and trustworthy company.",  
    pack3MiniDescription: "Transform your website into an unforgettable brand experience with interactive animations.",
    pack3Price: "From $XXX ",
    pack3SubPrice: "+ High monthly fee" ,
    pack3ResultsTittles: [  
      "Apple-level user experience",  
      "Greater differentiation and credibility",  
      "Increase in conversion"  
    ],  
    pack3Results: [  
      " with more engagement and retention on your website.",  
      " in the market with a striking visual proposal.",  
      " by visually guiding customers toward the purchase."  
    ],  
    pack3Includes: [  
      "EVERYTHING from Pack 1 and 2",  
      "Interactive animations",  
      "UX/UI service",  
      "Premium content",  
      "Data analysis"  
    ]  ,
    

    bookDemo: "Book a Demo",
    sendMessage: "Or send us a message with your questions",
    ownPack: "We create your Own Pack",
    talk: "Talk to an advisor",
    chair : "Chair",
    grill : "Grill",
    car : "Car",
    finalPrice : "Final Price:",
    configuratorsDescription: "Increase your average ticket by 25% and reduce operating costs by 70% with interactive 3D configurators that automate your sales.",
    animacionesDescription: "Highlight your product with 3D animations, showing its design and functions in a dynamic and attractive way.",
    rendersDescription: "Perfect photos without a photoshoot: 3D renders that showcase your product at its best.",
    arDescription: "Reduce returns by 50%: let your customers try the product before buying.",
    catalogDescription: "Fewer doubts, more sales: showcase your catalog in 3D and turn browsers into buyers.",
    contract: "Hire Service",
    animTittle: "3D Animations",
    name: "Name",
    correo: "Email",
    empresa: "Company",
    mensaje: "Message",
    enviar: "Send",
    contact: "Contact",
    contact2: "Start enjoying the benefits of Opptix",
    result: "Your message has been sent successfully. We will contact you shortly.",
    
    data1: "Increase in conversion rate",
    data2: "Reduction in returns",
    data3: "Increase in average ticket",
    data1AR: "Less Returns",
    data2AR: "Compatible with WebAr and mobile devices (without apps)",
    data3AR: "Immersive Experience",
    data1Anim: "+300% engagement on social media and ads",
    data2Anim: "Better recording with impactful content",
    data3Anim: "Differentiation with high quality materials",
    explore: "Explore More",
    agendar: "Schedule a Call",
    ARDescription: "With Augmented Reality (AR), users can see how products will look in their home, while with Virtual Reality (VR) they can immerse themselves in more immersive experiences.",
    scan: "Scan to see the product in your space",
  },
  es: {
    SeeButtonSimple: "Ver en tu espacio",
    whatIncludes : "¿Qué incluye?",
    prefeerCall : "Prefiero Agendar Llamada",
    ecommerceTittle: "Catálogo 3D",
    ecommerceText: "Menos dudas, más ventas: muestra tu catálogo en 3D y convierte curiosos en compradores.",
    agendar: "Agendar Llamada",
    hideBed: "Ocultar Cama",
    showBed: "Mostrar Cama",
    open: "Abrir",
    close: "Cerrar",
    services: "Servicios",
    servicesSub: "Podemos ayudarte en lo que necesites.",
    caseStudies: "Casos de Estudio",
    packs: "Packs",
    packsSub: "Descubre el que mejor se adapte a tu negocio.",
    ourServices: "Nuestros Servicios",
    getStarted: "Quiero Comenzar",
    bannerMain: "Revolucionando la Venta Online",
    bannerSecond: "Mejora la experiencia de compra con 3D y realidad aumentada.",
    popUpTittle: "TE REGALAMOS:",
    popUpText: "Nuestro configurador de producto, nuestra realidad aumentada y el modelo 3D de tu producto, GRATIS",
    secondaryBanner: "Estadísticas de Beneficios de trabajar con nosotros con números llamativos",
    workTogether: "¿Por qué trabajar juntos?",
    reason1: "Reducción de devoluciones",
    reason2: "Reducción de costos de atención al cliente",
    reason3: "Potencia tus ventas",
    reason4: "Incremento del ticket promedio con configuradores 3D",
    faq1: "¿Qué soluciones ofrece Opptix 3D para mejorar las ventas y el marketing de productos?",
    answer1: "En Opptix 3D creamos contenido visual innovador como configuradores de productos interactivos, realidad aumentada (AR) y animaciones de producto. Estas herramientas transforman la experiencia del cliente, aumentando la conversión y mejorando el engagement en plataformas digitales.",
    faq2: "¿Cómo funciona la realidad aumentada (AR) en mi e-commerce?",
    answer2: "Nuestra tecnología de realidad aumentada permite a los clientes visualizar productos en sus espacios reales usando la cámara de sus dispositivos móviles. Esto no solo genera confianza en la compra, sino que también reduce devoluciones al alinear las expectativas con la realidad.",
    faq3: "¿Qué tipo de productos pueden beneficiarse de configuradores 3D?",
    answer3: "Los configuradores 3D son ideales para productos personalizables como muebles, bicicletas, joyería, relojes, electrodomésticos y más. Si tu producto tiene variantes de color, tamaño, material o accesorios, un configurador 3D puede mejorar la experiencia del cliente y aumentar las VENTAS.",
    faq4: "¿Cuál es el proceso de creación de un modelo 3D de mi producto?",
    answer4: "Nuestro proceso incluye: Recolección de información (imágenes, planos técnicos o muestras físicas). Modelado 3D con atención al detalle y precisión. Revisión y ajustes en conjunto contigo. Optimización para diferentes usos, como e-commerce, redes sociales y campañas de marketing.",
    faq5: "¿Por qué elegir modelos 3D en lugar de fotografía tradicional?",
    answer5: "Los modelos 3D permiten: Mostrar productos desde todos los ángulos. Realizar cambios rápidos sin necesidad de repetir sesiones fotográficas. Crear contenido interactivo y atractivo. Reducir costos en fotografía y producción a largo plazo.",
    faq6: "¿Puedo usar los modelos 3D y las animaciones en redes sociales y campañas publicitarias?",
    answer6: "¡Por supuesto! Todos nuestros contenidos están optimizados para múltiples plataformas, como redes sociales, sitios web, e-commerce y campañas de publicidad. Diseñamos contenido versátil para maximizar el impacto en tu estrategia de marketing digital.",
    faq7: "¿Cuánto tiempo toma desarrollar configuradores 3D, modelos o animaciones?",
    answer7: "El tiempo depende de la complejidad del proyecto. Por ejemplo: Configuradores 3D: 2-4 semanas. Animaciones 3D: 1-2 semanas. Renders de alta calidad: 3-5 días. Siempre trabajamos para ofrecer soluciones rápidas sin comprometer la calidad.",
    faq8: "¿Cómo puedo implementar los modelos 3D en mi sitio web?",
    answer8: "Utilizamos iframes para incrustar modelos 3D y configuradores directamente en cualquier plataforma web, sin ralentizar el sitio ni requerir desarrollos costosos. Además, nuestro equipo técnico asegura una integración eficiente y sin complicaciones.",
    faq9: "¿Qué diferencia a Opptix 3D de otras agencias de contenido visual?",
    answer9: "No solo creamos contenido, sino que diseñamos experiencias. Nuestro enfoque está en destacar las características más importantes de tus productos, usando tecnología avanzada para maximizar la percepción de calidad y aumentar las ventas. Trabajamos codo a codo contigo para garantizar resultados personalizados y efectivos.",
    faq10: "¿Cómo pueden las soluciones 3D reducir las tasas de devolución en e-commerce?",
    answer10: "Al ofrecer visualizaciones detalladas, configuradores interactivos y AR, tus clientes tendrán una comprensión clara de los productos antes de comprarlos. Esto reduce malentendidos y alinea expectativas, disminuyendo devoluciones hasta en un 40%.",
    faq11: "¿Qué incluyen los packs de lanzamiento de producto?",
    answer11: "Nuestros packs de lanzamiento están diseñados para maximizar el impacto. Incluyen: Renders 3D en alta calidad. Videos explicativos y comerciales en 3D. Animaciones para redes sociales. Configuradores interactivos para personalización. Todo creado en colaboración contigo para garantizar que tus objetivos se cumplan.",
    faq12: "¿Cómo miden el impacto de los modelos y configuradores 3D en el rendimiento de mi negocio?",
    answer12: "Analizamos métricas como: Incremento en la tasa de conversión. Mayor tiempo de permanencia en el sitio. Reducción en tasas de devolución. Incremento en ventas promedio gracias a configuraciones personalizadas. Compartimos estos datos contigo para que compruebes el valor agregado de nuestras soluciones.",
    faq13: "¿Qué tan accesibles son los servicios de Opptix 3D para pequeñas y medianas empresas?",
    answer13: "Diseñamos soluciones adaptadas a diferentes presupuestos y necesidades. Ya sea que estés comenzando o seas una gran empresa, nuestros servicios ofrecen un retorno de inversión significativo a precios competitivos.",
    faq14: "¿Qué pasa si no tengo un modelo 3D inicial de mi producto?",
    answer14: "¡No te preocupes! Nuestro equipo puede crear el modelo 3D desde cero con imágenes, planos técnicos o incluso descripciones detalladas. Nos encargamos de todo para que obtengas resultados óptimos.",
    faq15: "¿Cómo puedo empezar a trabajar con Opptix 3D?",
    answer15: "Simplemente contáctanos para una llamada inicial o envíanos detalles sobre tu proyecto. Diseñaremos un plan personalizado y te guiaremos paso a paso para implementar soluciones que transformen tu negocio.",
    faqTitle: "Preguntas Frecuentes",
    seeMore: "Ver Más",
    caseStudies: "Casos de Estudio",
    caseStudiesSubt: "La mejor calidad para tu marca.",
    showMore: "Ver Más",
    showLess: "Ver Menos",

    configText: "Aumenta tu ticket promedio un 25% y reduce costos operativos un 70% con configuradores 3D interactivos, que automatizan tus ventas.",
    arText: "Reduce devoluciones en un 50%: deja que tus clientes prueben el producto antes de comprar.",
    viewerText: "Menos dudas, más ventas: muestra tu catálogo en 3D y convierte curiosos en compradores.",
    marketingText: "Duplica el engagement y haz que tu marca cobre vida con animaciones 3D de alto impacto.",
    staticRenderText: "Fotos perfectas sin sesión de fotos: renders 3D que muestran tu producto en su mejor versión.",
    interactivAnimText: "Atrae, retiene y vende: animaciones interactivas que duplican la retención y el engagement.",

    configTittle: "Configuradores 3D",
    marketingTittle: "Animaciones",
    arTittle: "Realidad Aumentada",
    staticRenderTittle: "Renders estáticos",
    viewerTittle: "Visualizador productos 3D",
    interactivAnimTittle: "Animaciones interactivas",

  pack1Title: "Más confianza, más conversión",
  pack1Description: "Tus clientes podrán ver tu producto desde todos los ángulos y visualizarlo en su espacio real antes de comprarlo. Esto genera más confianza, reduce la indecisión y aumenta la tasa de conversión en tu e-commerce.",
  pack1MiniDescription: "Tus clientes podrán ver tu producto desde todos los ángulos y visualizarlo en su espacio real antes de comprarlo.",
  pack1Price: "Desde $XXX",
  pack1SubPrice: "+ Fee mensual bajo",
  pack1ResultsTittles: [
    "Reducción del 40%",
    "Aumento del 20-30%",
    "Experiencia de compra"
  ],
  pack1Results: [
    " en devoluciones gracias a una mejor percepción del producto.",
    " en la tasa de conversión al eliminar dudas del cliente.",
    " más inmersiva y profesional, diferenciándote de la competencia."
  ],
  pack1Includes: [
    "Catálogo 3D interactivo (iFrame)",
    "Visualización en AR",
    "Optimización del rendimiento web"
  ],

  pack2Title: "Más ventas, menos costos",
  pack2Description: "Convierte tu tienda en un showroom digital donde los clientes pueden personalizar productos en tiempo real. Esto no solo aumenta la conversión, sino que también incrementa el ticket promedio gracias a opciones de personalización y venta cruzada.",
  pack2MiniDescription: "Convierte tu tienda en un showroom digital donde los clientes pueden personalizar productos en tiempo real.",
  pack2Price: "Desde $XXX",
  pack2SubPrice: "+ Fee mensual intermedio",
  pack2ResultsTittles: [
    "Hasta 40% más de ventas",
    "Incremento del ticket promedio",
    "Menos costos de atención"
  ],
  pack2Results: [
    " gracias a la personalización interactiva.",
    " al ofrecer accesorios y mejoras adicionales.",
    " ya que el cliente diseña su producto sin requerir asistencia."
  ],
  pack2Includes: [
    "TODO lo del Pack 1",
    "Configurador 3D interactivo",
    "Venta cruzada y upsells dinámicos",
    "Asesoría UX/UI",
    "Data analysis",
    "Pack de renders"
  ],

  pack3Title: "Experiencia Premium",
  pack3Description: "Transforma tu web en una experiencia de marca inolvidable con animaciones y modelos 3D con los que el cliente puede interactuar. Esto no solo mejora la percepción de tu marca, sino que te posiciona como una empresa innovadora y confiable.",
  pack3MiniDescription: "Transforma tu web en una experiencia de marca inolvidable con animaciones interactivas.",
  pack3Price: "Desde $XXX",
  pack3SubPrice: "+ Fee mensual alto",
  pack3ResultsTittles: [
    "Experiencia de usuario nivel Apple",
    "Mayor diferenciación y credibilidad",
    "Aumento en conversión"
  ],
  pack3Results: [
    " con más engagement y retención en tu web.",
    " en el mercado con una propuesta visual impactante.",
    " al guiar al cliente visualmente hacia la compra."
  ],
  pack3Includes: [
    "TODO lo del Pack 1 y 2",
    "Animaciones interactivas",
    "Servicio UX/UI",
    "Contenido premium",
    "Data analysis"
  ],

    bookDemo: "Reserva una Demostración",
    sendMessage: "O envíenos un mensaje con sus preguntas",
    ownPack: "Creamos tu Propio Pack",
    talk: "Hablar con un asesor",
    chair : "Sillón",
    grill : "Parrilla",
    car : "Auto",
    finalPrice: "Precio Final:",
    configuratorsDescription: "Aumenta tu ticket promedio un 25% y reduce costos operativos un 70% con configuradores 3D interactivos, que automatizan tus ventas.",
    animacionesDescription: "Destaca tu producto con animaciones 3D, mostrando su diseño y funciones de forma dinámica y atractiva.",
    rendersDescription: "Fotos perfectas sin sesión de fotos: renders 3D que muestran tu producto en su mejor versión.",
    arDescription: "Reduce devoluciones en un 50%: deja que tus clientes prueben el producto antes de comprar.",
    catalogDescription: "Menos dudas, más ventas: muestra tu catálogo en 3D y convierte curiosos en compradores.",
    contract: "Contratar Servicio",
    animTittle : "Animaciones 3D",
    name: "Nombre",
    correo: "Correo",
    empresa: "Empresa",
    mensaje: "Mensaje",
    enviar: "Enviar",
    contact: "Contacto",
    contact2: "Empieza a disfrutar los beneficios de Opptix",
    result: "Tu mensaje ha sido enviado con éxito. Nos pondremos en contacto contigo en breve.",

    data1: "+40% ventas con personalización interactiva",
    data2: "Boleto mayor con upsells y crossselling",
    data3: "Menos costos al automatizar la configuración",
    data1AR: "Menos Devoluciones",
    data2AR: "Compatible con WebAr y móviles (sin apps)",
    data3AR: "Experiencia Inmersiva",
    data1Anim: "+300% engagement en redes sociales y anuncios",
    data2Anim: "Mejor grabación con contenido impactante",
    data3Anim: "Diferenciación con materiales de alta calidad",
    explore: "Explorar Más",
    ARDescription: "Con Realidad Aumentada (AR), los usuarios pueden ver cómo se verán los productos en su hogar, mientras que con Realidad Virtual (VR) pueden sumergirse en experiencias más envolventes.",
    scan: "Escaneá para verlo en la vida real."
  }
};
  

export const translate = (key, language) => {
    if (translations[language] && translations[language][key]) {
      return translations[language][key];
    }
    console.warn(`Translation missing for key "${key}" in language "${language}"`);
    return key;
  };
  
  export default translations;
  